import { render, staticRenderFns } from "./MenuBarGpt.vue?vue&type=template&id=6a19e8b4&scoped=true"
import script from "./MenuBarGpt.vue?vue&type=script&lang=js"
export * from "./MenuBarGpt.vue?vue&type=script&lang=js"
import style0 from "./MenuBarGpt.vue?vue&type=style&index=0&id=6a19e8b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a19e8b4",
  null
  
)

export default component.exports